import { Component, Input, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-program-schedule-graphic',
  templateUrl: './program-schedule-graphic.component.svg',
  styleUrls: ['./program-schedule-graphic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProgramScheduleGraphicComponent {
  @ViewChild('svgRef')
  svgRef!: ElementRef<SVGElement>;  
  @Input() changing!: Subject<boolean>;
  @Input() days!: any[];
  @Input() minutes!: any[];
  @Input() programs!: any[];
  @Input() parentClick: boolean = false;
  fillColor = 'rgb(195, 195, 195)';

  dayText = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  ngOnInit(){
    this.changing.subscribe(v => { 
      this.downloadSvg()
    });
  }

  changeColor() {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    this.fillColor = `rgb(${r}, ${g}, ${b})`;
  }

  studioColor(studio) {
    const h = studio * 180;
    const s = 70;
    const l = 35;
    return `hsl(${h}deg, ${s}%, ${l}%)`;
  }

  downloadSvg() {

    console.log(this.svgRef)
    const serializer = new XMLSerializer();
    var source = serializer.serializeToString(this.svgRef.nativeElement);
    source = source.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink='); // Fix root xlink without namespace

    source = source.replace(/ns\d+:href/g, 'xlink:href'); // Safari NS namespace fix.


    if (!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
      source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
    }
    if (!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
      source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
    }

    if (!source.match(/ class="ng-star-inserted"/)) {
      source = source.replace(/ class="ng-star-inserted"/g, '');
    }



    var preface = '<?xml version="1.0" standalone="no"?>\r\n';

    console.log(preface + source)

    const blob = new File([preface + source], 'grid.svg', { type: 'image/svg+xml;charset=utf-8' });
		const url = window.URL.createObjectURL(blob);
		window.open(url);

    // var downloadLink = document.createElement("a");
    // downloadLink.href = svgUrl;
    // downloadLink.download = name;
    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    // document.body.removeChild(downloadLink);

  }
}
